import { useApplicationId, useApplicationPageMutation } from "./aggregatedData";
export function useDismissManualInspection() {
  var applicationId = useApplicationId();
  var _useApplicationPageMu = useApplicationPageMutation(function () {
      return {
        url: '/api/v2/manual_inspection',
        method: 'POST',
        body: {
          applicationId: applicationId
        }
      };
    }),
    mutate = _useApplicationPageMu.mutate,
    isLoading = _useApplicationPageMu.isLoading;
  return {
    dismissManualInspection: mutate,
    isDismissingManualInspection: isLoading
  };
}